/**
 * SweetAlert2 is only needed when an alert is actually shown, so it is loaded on demand
 * instead of being bundled into the main chunk through the redux slices.
 * Usage is identical to the previous `withReactContent(Swal)`: `await Alert.fire({...})`.
 */
let alertPromise;

const getAlert = () => {
  if (!alertPromise) {
    alertPromise = Promise.all([
      import("sweetalert2"),
      import("sweetalert2-react-content"),
    ]).then(([swal, withReactContent]) => withReactContent.default(swal.default));
  }
  return alertPromise;
};

const Alert = {
  fire: (options) => getAlert().then((alert) => alert.fire(options)),
};

export default Alert;
